import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function uniqueProfileNameInOrgValidator(
  getProfiles: () => any[],
  getCurrentConfigId?: () => string | null | undefined,
  nameControlPath: string = "name",
  orgIdControlPath: string = "organization.id",
  excludeCurrentProfile: boolean = true,
  getDefaultOrgId?: () => string | number | null | undefined
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const selectedOrgId = control.get(orgIdControlPath)?.value;
    const hasSelectedOrg = selectedOrgId !== null && selectedOrgId !== undefined && selectedOrgId !== "";
    const orgId = hasSelectedOrg ? selectedOrgId : getDefaultOrgId?.();
    const name = control.get(nameControlPath)?.value;

    if (!orgId || !name) {
      return null;
    }

    const profiles = getProfiles();

    console.log("In uniqueProfileNameInOrgValidator() - profiles = ", profiles)

    if (!profiles?.length) {
      return null;
    }

    const normalizedName = String(name).trim().toLowerCase();
    const normalizedOrgId = String(orgId);
    const currentConfigId = getCurrentConfigId?.();

    const duplicate = profiles.some(profile =>
      String(profile.orgId) === normalizedOrgId &&
      profile.name?.trim().toLowerCase() === normalizedName &&
      (!excludeCurrentProfile || profile.id !== currentConfigId)
    );

    console.log("In uniqueProfileNameInOrgValidator() - duplicate = ", duplicate)

    return duplicate
      ? {
          uniqueProfileNameInOrg: {
            value: name,
            organizationId: orgId
          }
        }
      : null;
  };
}
